import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AsyncPaginate from 'react-select-async-paginate';

import CreatableSelect from 'react-select/creatable';
import './CreatableSelect.scss';

const CreatablePaginatedSelect = ({
  label,
  containerClassName,
  labelClassName,
  valid,
  id,
  hideIndicator,
  helperText,
  readOnly,
  ...props
}) => {
  const handleChange = value => {
    if (props.onChange) {
      props.onChange({ target: { value, name: props.name } });
    }
  };
  const handleBlur = () => {
    if (props.onBlur) {
      props.onBlur({ target: { name: props.name } });
    }
  };

  return (
    <div
      className={classNames('form-group form-group-mob', containerClassName, {
        'is-invalid': valid === false,
        'is-valid': valid === true,
        'is-readonly': readOnly,
      })}
    >
      {label && (
        <label
          className={classNames('form-control-label', labelClassName, {
            'is-invalid': valid === false,
            'is-valid': valid === true,
          })}
          htmlFor={id}
        >
          {label}
        </label>
      )}
      <AsyncPaginate
        SelectComponent={CreatableSelect}
        isClearable
        {...props}
        // styles={customStyles}
        className={classNames({
          'hide-indicator': hideIndicator,
          'is-invalid': valid === false,
          'is-valid': valid === true,
        })}
        classNamePrefix="creatable-select"
        onChange={handleChange}
        onBlur={handleBlur}
      />
      {valid === false && (
        <div className="invalid-feedback text-left d-block">{props.invalidFeedback}</div>
      )}
      {valid === true && (
        <div className="valid-feedback text-left d-block">{props.validFeedback}</div>
      )}
      {helperText && valid === undefined && (
        <small className="form-text text-muted text-left d-block">{helperText}</small>
      )}
    </div>
  );
};
CreatablePaginatedSelect.propTypes = {
  hideIndicator: PropTypes.bool,
};

CreatablePaginatedSelect.defaultProps = {
  hideIndicator: false,
};

export default CreatablePaginatedSelect;
